define([
	"dojo/_base/declare",
	"csi/action",
	"csi/action/FormData",
	"csi/table/Aggregate",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"BusinessPlanning/ProductPlanProductMixin"
], function(declare,action,FormData,Aggregate,ActionControllerMixin,xml,ProductPlanProductMixin) {

	return declare([Aggregate, ActionControllerMixin, ProductPlanProductMixin], {
		_fdPage2: null,

		constructor: function(/*Object*/params) {
			var actionId = this.m_action.m_id;
			if(actionId == "SelectStyleSize") {
				this.productClass = this._STYLE;
				this.__aggregateClassId = this._PRODUCT_SIZE;
			} else if(actionId == "SelectMaterialSize") {
				this.productClass = this._MATERIAL;
				this.__aggregateClassId = this._PRODUCT_SIZE;
			} else if(actionId == "SelectSKU") {
				this.productClass = this._STYLE;
				this.__aggregateClassId = this._REALIZED_PRODUCT;
			} else if(actionId == "SelectSKUMaterial") {
				this.productClass = this._MATERIAL;
				this.__aggregateClassId = this._REALIZED_PRODUCT;
			}
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: apply filters to wizard views
			if (index == 0) {
				// filter out products by filters defined on the BusinessPlan
				return this._getQuery();
			} else if (index == 1 && this.__aggregateClassId == this._PRODUCT_COLOR) {
				// query for ProductColor with Active = true
				return this._activeQuery();
			}

			return null;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var indexOfPage = wizard.getIndexOfPage(nextPage);
			var	bRefresh = false;
			var	dfd, fd;

			if (indexOfPage == 0) {
				// moving to Products table
				fd = this.m_formData;
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			} else if (indexOfPage == 1) {
				// moving to ProductSizes table view of selected Product
				var	product = wizard.getFormDataFromPage(currentPage).getSelectedNode();

				// initialize form data
				fd = this._fdPage2 = this._fdPage2 || new FormData(this);
				if (fd.getNode() != product) {
					fd.setNode(product);
					fd.resetAggregations();
					fd.resetSelections();
					bRefresh = true;
				}
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			}

			return fd ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		_onAction: function() {
			// summary: Set BPProductPlan.ProductSize attribute
			if (this._fdPage2 && this.__aggregateClassId) {
				var urlSize = this._fdPage2.getSelectedNode().$URL;
				if(xml.isValidURL(urlSize))
					this.m_writer.changeNode(this.m_urlParent).changeAttribute(this.__aggregateClassId, xml.ATTR_REF, urlSize);
			}
		},

		postProcessSuccess: function() {
			// summary: refresh row
			this.widget.redrawNode(this.refNode);
		}
	});
});